import { render } from "./DrugstoreListMobile.vue?vue&type=template&id=193a7571&scoped=true&lang=pug"
import script from "./DrugstoreListMobile.vue?vue&type=script&lang=js"
export * from "./DrugstoreListMobile.vue?vue&type=script&lang=js"

import "./DrugstoreListMobile.vue?vue&type=style&index=0&id=193a7571&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193a7571"]])

export default __exports__
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerDots,QBtn,QIcon,QImg,QExpansionItem,QScrollArea,QSlideTransition,QItem});
